import { React, useEffect, useContext } from "react";
import Axios from "axios";
import HomeDataContextProvider from "../contexts/HomeDataContext";
import WelcomePageForm from "../components/WelcomePageForm";
import SuccessModal from "../components/SuccessModal";
import FailureModal from "../components/FailureModal";

import { HomeDataContext } from "../contexts/HomeDataContext";
import { deleteLocalStorage, authHeader, gettokens } from "../helpers/auth-header";
import { userService } from '../services/UserService';
const WelcomePage = () => {


	return (
		<HomeDataContextProvider>
			<WelcomePageForm />
			<FailureModal />
			<SuccessModal />

		</HomeDataContextProvider>
	);
};

export default WelcomePage;

